module.exports = __webpack_public_path__ + "static/media/11.8e9000a8.JPG";